import React, { useState, useEffect, useRef } from "react";
import { IFintechLayout,Plan} from "../../types/types";
import check_nudgemoney from "../../assets/Images/check_nudgemoney.png";
import arrow_nudgemoney from "../../assets/Images/arrow_nudgemoney.png";
import { useTranslation } from "react-i18next";
export interface ISlide {
  icon: string;
  title: string;
  description: string;
  buttonText: string;
  subscriptionDetails: string;
  termsTitle: string;
  source:Plan;
  goals?: string[];
}

interface INudgeMoneySliderProps {
  slides: ISlide[] | undefined;
  onSlideClick: (plan: Plan | undefined) => void;
  isSubscribed: boolean;
  isExistSubscriptionPlans: boolean;
  layout: IFintechLayout | undefined | null;
  setIsShowBackButton: React.Dispatch<React.SetStateAction<boolean>>; // Add this property
}

interface IFeatureItemProps {
  text: string;
}

const FeatureItem: React.FC<IFeatureItemProps> = ({ text }) => {
  return (
    <>
    <div className="flex flex-row items-center mb-3 mt-3">
      <div>
        <img src={check_nudgemoney} alt="feature-icon" className="w-6 h-6 mr-2" />
      </div>
      <div>
        <span className="font-poppins text-base/6 font-medium">{text}</span>
      </div>
    </div>
    <div className="w-full">
      <hr className="border-gray-400"></hr>
    </div>
    </>
  );
};

const NudgeMoneySlider: React.FC<INudgeMoneySliderProps> = ({
  slides,
  onSlideClick,
  isExistSubscriptionPlans,
  layout,
  setIsShowBackButton, // Destructure the new property
}) => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const sliderRef = useRef<HTMLDivElement | null>(null);
  const startXRef = useRef<number>(0);
  const dragOffsetRef = useRef<number>(0);
  const [dragOffset, setDragOffset] = useState<number>(0);
  const [isContinueMode, setIsContinueMode] = useState(false);
  const [isDetailsMode, setIsDetailsMode] = useState(false);
  const { t } = useTranslation();
  

  useEffect(() => {
    if (isDetailsMode) {
      setIsShowBackButton(false); // Hide back button when in details mode
    } else {
      setIsShowBackButton(true); // Show back button otherwise
    }
  }, [isDetailsMode, setIsShowBackButton]);

  const handleStart = (clientX: number) => {
    startXRef.current = clientX;
    dragOffsetRef.current=0
    setIsDragging(true);
    setDragOffset(0);
   
  };

  const handleMove = (clientX: number) => {
    if (!isDragging) return;
    const diff = startXRef.current - clientX;
    dragOffsetRef.current = diff;
    setDragOffset(diff);
  };

  const handleEnd = () => {
    if (!isDragging) return;
    const threshold = (sliderRef.current?.offsetWidth ?? 0) / 3;
    
    if (Math.abs(dragOffsetRef.current) > threshold) {
      if (dragOffsetRef.current > 0 && currentSlide < (slides?.length??0) - 1) {
        setCurrentSlide((prev) => prev + 1);
      } else if (dragOffsetRef.current < 0 && currentSlide > 0) {
        setCurrentSlide((prev) => prev - 1);
      }
    }

    setIsDragging(false);
    setDragOffset(0);
  };

  const handleDotClick = (index: number) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const slider = sliderRef.current;

    if (!slider) return;

    const touchStart = (e: TouchEvent) => handleStart(e.touches[0].clientX);
    const touchMove = (e: TouchEvent) => handleMove(e.touches[0].clientX);
    const touchEnd = () => handleEnd();

    const mouseDown = (e: MouseEvent) => handleStart(e.clientX);
    const mouseMove = (e: MouseEvent) => handleMove(e.clientX);
    const mouseUp = () => handleEnd();

    slider.addEventListener("touchstart", touchStart, { passive: true });
    slider.addEventListener("touchmove", touchMove, { passive: true });
    slider.addEventListener("touchend", touchEnd);
    slider.addEventListener("mousedown", mouseDown);
    window.addEventListener("mousemove", mouseMove);
    window.addEventListener("mouseup", mouseUp);

    return () => {
      slider.removeEventListener("touchstart", touchStart);
      slider.removeEventListener("touchmove", touchMove);
      slider.removeEventListener("touchend", touchEnd);
      slider.removeEventListener("mousedown", mouseDown);
      window.removeEventListener("mousemove", mouseMove);
      window.removeEventListener("mouseup", mouseUp);
    };
  }, [isDragging, slides,isDetailsMode]);

  if(isDetailsMode){
    return (
      <div className="w-full overflow-hidden  bg-[#FDFDFD] rounded-xl flex-shrink-0 mt-5 pb-5"> 
        <div className="flex  flex-col  items-start mt-4 text-[#4E4E4E] pl-5 pr-5 pb-5" >

        <div className="flex flex-row items-center mb-2 mt-3"
          onClick={() => {setIsDetailsMode(false);}}
        >
            <div>
              <img src={arrow_nudgemoney} alt="feature-icon" className="w-6 h-6 mr-2 rotate-180" />
            </div>
            <div >
              <span className="font-poppins text-center font-semibold text-base/6 font-medium"
               style={{color: layout?.buttonColor || "#000000"}}
              >{t("return")}</span>
            </div>
        </div>
      </div>
      <div className="text-[#4E4E4E] flex flex-col text-left text-start font-poppins  text-xl/5 font-medium ml-5 mr-5 mt-2 mb-3">
            {slides?.[currentSlide]?.termsTitle || "Terms and Conditions"}
      </div>
      <div className="text-[#4E4E4E] flex flex-col items-center  text-start font-poppins  text-sm/5 ml-5 mr-5 mt-2">
            {slides?.[currentSlide]?.subscriptionDetails}
      </div>
    </div>
    )
  }

  return (
    <div
      ref={sliderRef}
      className="w-full flex-grow overflow-hidden flex flex-col  mt-8"
    >


      <div className="w-full overflow-hidden  bg-[#FDFDFD] rounded-xl flex-shrink-0">
        <div className="overflow-y-auto">
          <h3 className=" mb-2 text-black  font-poppins text-center text-xl/5 font-medium mt-4" 
           style={{color: layout?.buttonColor || "#000000"}}
          >
            {slides?.[currentSlide].title}
          </h3>

        </div>
        <div
          className="flex transition-transform duration-300 ease-out"
          style={{
            transform: `translateX(calc(-${currentSlide * 100}% + ${
              isDragging ? -dragOffset : 0
            }px))`,
            transition: isDragging ? "none" : "transform 300ms ease-out",
          }}
        >
          {slides?.map((slide, index) => (
            <div
              key={index}
              className="w-full flex-shrink-0 pl-10  pr-10 pt-2 pb-2 flex flex-col justify-center items-center"
            >
              <div className="text-[#4E4E4E] flex flex-col items-center justify-center text-start font-poppins  text-base/6">
                {slide?.description}
              </div>

            </div>
          ))}
         
        </div>
        <div className="flex  flex-col  items-start mt-4 text-[#4E4E4E] pl-5 pr-5 pb-5" >
          {slides?.[currentSlide]?.goals?.map((goal, index) => (
             <FeatureItem key={index} text={goal} />  
          ))}


          <div className="flex flex-row items-center mb-3 mt-3">
            <div>
              <img src={arrow_nudgemoney} alt="feature-icon" className="w-6 h-6 mr-2" />
            </div>
            <div 
              onClick={() => {setIsDetailsMode(true);}}
            >
              <span className="font-poppins text-center font-semibold text-base/6 font-medium"
               style={{color: layout?.buttonColor || "#000000"}}
              >{t("seeMore")}</span>
            </div>
          </div>

        </div>
      </div>

      <div className="flex flex-col flex-grow overflow-y-hidden h-auto sm:h-60 bg-transparent justify-between p-4">


        <div className="flex  justify-center  my-4 align-middle">
          <div className="text-black  dark:text-[#FDFDFD] align-top text-2xl ml-5 mr-3 w-4"
            onClick={() => {
              if (currentSlide > 0) {
                setCurrentSlide((prev) => prev - 1);
              }
            }}
          >
            {currentSlide===0?' ':'<'}
          </div>
          {slides?.map((_, index) => (
            <div className="flex items-center space-x-2 align-middle justify-center mr-1 ml-1" key={index}>
              <div
                key={index}
                onClick={() => handleDotClick(index)}
                className={`w-2 h-2 rounded-full cursor-pointer ${
                  index === currentSlide ? "bg-black  dark:bg-[#FDFDFD] scale-150" : "bg-gray-300"
                }`}
              />
            </div>
            
          ))}
          <div className="text-black  dark:text-[#FDFDFD] align-top text-2xl mr-5 ml-3 w-4"
            onClick={() => {
              if (currentSlide < (slides?.length??0) - 1) {
                setCurrentSlide((prev) => prev + 1);
              }
            }}
          >
            {currentSlide < (slides?.length??0) - 1 ? '>' : ' '}
          </div>
        </div>
        <div className="flex flex-col justify-between items-center">
          {!isContinueMode && (
            <button
              onClick={() => setIsContinueMode(true)}
              className="w-full  text-white py-3 rounded-lg shadow-md font-poppins font-semibold uppercase"
              style={layout?.buttonStyle}
            >
              {t("continue")} 
            </button>
          )}

          {isContinueMode && isExistSubscriptionPlans && (
            <button
              onClick={() => onSlideClick(slides?.[currentSlide]?.source)}
              className="w-full bg-[#EBAE11] text-white py-3 rounded-lg shadow-md font-poppins font-semibold uppercase text-lg/6"
              style={layout?.buttonStyle}
            >
              {slides?.[currentSlide].buttonText || 'SUBSCRIBE'}
            </button>
          )}
          {isContinueMode && !isExistSubscriptionPlans && (
            <div className="mb-2 text-black font-poppins">
              {t("subscriptionPlansNotAvailable")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NudgeMoneySlider;